export default {
  placeholder: 'Wybierz język',
};
